export const moduleRoutes = {
    list: 'workbooks/',
    sync: 'workbooks/synchronize-tableau/',
    workbooklogs: 'workbooklogs/',
};
